import { BootstrapToolTip } from '@/_elements/ToolTip';
import { fetchWrapper, getTeamIdFromURL } from '@/_helpers';
import { ActionStyles } from '@/components/Admin/reusableStyles';
import React, { Fragment, useEffect, useState } from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';
import { BiMove, BiUserPlus } from 'react-icons/bi';
import Select from 'react-select';
import { toast } from 'react-toastify';
const NONE_OPTION = {
    value: '000000000000000000000000',
    label: '-- None --',
};

const MoveStaffModal = ({
    staff,
    fetchUnassignedStaff = () => {},
    unassignedList,
    handleUpdateEmployee = () => {},
    providerId,
    onSave = () => {},
}) => {
    const teamId = getTeamIdFromURL();
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const [buckets, setBuckets] = useState([]);
    const [targetBucket, setTargetBucket] = useState(null);
    const [skipActivityPlan, setSkipActivityPlan] = useState(false);

    const onSelectBucket = (bucket) => {
        setTargetBucket(bucket);
    };

    const onToggleSkip = () => {
        setSkipActivityPlan(!skipActivityPlan);
    };

    const [isLoading, setIsLoading] = useState(false);
    const fetchBuckets = async () => {
        try {
            setIsLoading(true);
            const response = await fetchWrapper.get(`staffBuckets?team=${teamId}&provider=${providerId}`);
            const bucketOptions = (response.results || [])
                .sort((a, b) => a.sequence - b.sequence)
                .map((b) => ({
                    value: b._id,
                    label: b.name,
                    activityPlan: b.activityPlan,
                }));

            setBuckets([NONE_OPTION, ...bucketOptions]);
        } catch (error) {
            toast.error('Failed to fetch buckets');
            console.error('Error fetching buckets:', error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleMoveStaff = async () => {
        try {
            console.log({ targetBucket });
            const bucketId = targetBucket?.value || targetBucket?._id;
            setIsLoading(true);
            const response = await fetchWrapper.post(`staffBuckets/${bucketId}/staff?team=${teamId}`, {
                staffId: staff._id,
                skipActivityPlan,
            });
            toast.success('Staff moved successfully');
            handleUpdateEmployee({
                ...staff,
                bucket: (response?.staff || {})?.bucket,
            });
            await fetchUnassignedStaff();
            await onSave();
        } catch (error) {
            toast.error('Failed to move staff');
            console.error('Error moving staff:', error);
        } finally {
            setIsLoading(false);
            handleClose();
        }
    };
    useEffect(() => {
        if (show) {
            fetchBuckets();
        }
    }, [show]);

    useEffect(() => {
        if (show && buckets && staff?.bucket) {
            const currentBucketId = typeof staff.bucket === 'string' ? staff.bucket : staff.bucket?._id;
            const bucket = buckets.find((b) => b.value === currentBucketId);

            if (bucket) {
                setTargetBucket(bucket);
            }
        }
    }, [show, buckets]);

    return (
        <Fragment>
            <ActionStyles>
                {unassignedList ? (
                    <BootstrapToolTip text="Assign To Bucket">
                        <BiUserPlus size={18} className="icon assign" onClick={handleShow} />
                    </BootstrapToolTip>
                ) : (
                    <BootstrapToolTip text="Move Staff To New Bucket">
                        <BiMove size={18} className="icon assign" onClick={handleShow} />
                    </BootstrapToolTip>
                )}
            </ActionStyles>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Move Staff to Bucket</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        Move{' '}
                        <strong>
                            {staff?.firstName} {staff?.lastName}
                        </strong>{' '}
                        to a new bucket.
                    </p>

                    <Form.Group>
                        <Form.Label>Target Bucket</Form.Label>
                        <Select
                            options={buckets}
                            value={targetBucket}
                            onChange={onSelectBucket}
                            placeholder="Select a bucket"
                            disabled={isLoading}
                        />
                    </Form.Group>

                    {targetBucket?.activityPlan && (
                        <Form.Group>
                            <Form.Check
                                type="checkbox"
                                id="skipActivityPlan"
                                label={`Skip assigning activity plan "${targetBucket.activityPlan.name}"`}
                                checked={skipActivityPlan}
                                onChange={onToggleSkip}
                            />
                        </Form.Group>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleMoveStaff} disabled={!targetBucket || isLoading}>
                        {isLoading ? <Spinner animation="border" size="sm" /> : 'Move Staff'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </Fragment>
    );
};

export default MoveStaffModal;
